<template>
  <div>
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <b-card v-if="this.loadpage == false" no-body>
      <b-card-header header-bg-variant="light">
        <h5 class="font-weight-bolder">รายการแจ้งออกของวันที่ {{formatDatetime(this.requestInfo[0].informDate)}}</h5>
      </b-card-header>
      <b-card-body>
        <h3 class="py-1"><u>รายการที่แจ้ง</u></h3>
        <!-- pc -->
        <b-table
          class="position-relative d-none d-sm-block"
          bordered
          responsive
          small
          :items="requestInfo"
          :fields="requestFields"
        >
          <template #cell(receiveDate)="data">
            {{formatDatetime(data.value)}}
          </template>
          <template #cell(offChinaDate)="data">
            {{formatDatetime(data.value)}}
          </template>
          <template #cell(arrivedThaiDate)="data">
            {{formatDatetime(data.value)}}
          </template>
          <template #cell(requestId)="data">
            <div v-if="data.item.statusId != 2">
              <feather-icon
                :id="`delete-icon-${data.value}`"
                icon="TrashIcon"
                class="cursor-pointer text-danger"
                size="20"
                @click="deleteRequestPacking(data.item)"
              />
              <b-tooltip
                title="ลบ"
                :target="`delete-icon-${data.value}`"
              />
            </div>
          </template>
        </b-table>
        <!-- mobile -->
        <div class="d-block d-sm-none">
          <b-card
            v-for="(item, index) in requestInfo"
            :key="index"
            no-body
            role="tablist"
            class="mb-0"
          >
            <b-card-body header-tag="header" role="tab" class="py-0 px-0">
              <b-row>
                <b-col>
                  <span class="font-weight-bold">{{item.trackingNo}}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <span>{{item.remark}}</span>
                </b-col>
                <b-col class="text-right align-items-center">
                  <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="flat-primary"
                    class="btn-icon rounded-circle float-right pr-0"
                    v-b-toggle="'card-'+index"
                  >
                    <span>เพิ่มเติม </span>
                    <span class="when-opened">
                      <feather-icon icon="ChevronUpIcon" />
                    </span>
                    <span class="when-closed">
                      <feather-icon icon="ChevronDownIcon" />
                    </span>
                  </b-button>
                </b-col>
              </b-row>
            </b-card-body>
            <b-collapse :id="'card-'+index" accordion="card" role="tabpanel" class="py-0">
              <b-row class="pb-1 pl-1">
                <b-col cols="4"  class="pr-0">รับเข้าโกดังจีน:</b-col>
                <b-col>{{formatDatetime(item.receiveDate)}}</b-col>
              </b-row>
              <b-row class="pb-1 pl-1">
                <b-col cols="4" class="pr-0">ออกจากจีน:</b-col>
                <b-col>{{formatDatetime(item.offChinaDate)}}</b-col>
              </b-row>
              <b-row class="pb-1 pl-1">
                <b-col cols="4" class="pr-0">ถึงไทย:</b-col>
                <b-col>{{formatDatetime(item.arrivedThaiDate)}}</b-col>
              </b-row>
              <b-button v-if="item.statusId != 2"	 @click="deleteRequestPacking(item)" class="btn-icon float-right mb-1" variant="danger">
                <feather-icon class="icon" icon="Trash2Icon" size="15"/>
              </b-button>
            </b-collapse>
            <hr class="dense">
          </b-card>
        </div>
        <h3 class="py-md-1 pb-1"><u>ที่อยู่จัดส่ง</u></h3>
        <b-form>
          <b-row >
            <b-col cols="12">
              <b-form-group label="จัดส่งโดย :" label-class="py-0 font-weight-bolder" label-cols-md="3">
                {{this.requestInfo[0].domesticDesc}}
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="ที่อยู่จัดส่ง :" label-class="py-0 font-weight-bolder" label-cols-md="3">
                {{this.requestInfo[0].name}} โทร.{{this.requestInfo[0].phone}} {{this.requestInfo[0].address}} ต.{{this.requestInfo[0].tumbol}} อ.{{this.requestInfo[0].amphor}} จ.{{this.requestInfo[0].provinceName}} {{this.requestInfo[0].postcode}}
              </b-form-group>
            </b-col>
            <b-col cols="12" >
              <b-form-group label="รูปแบบ :" label-class="py-0 font-weight-bolder" label-cols-md="3">
                <div v-if="this.requestInfo[0].isOnlyRequest == true" >
                  ออกเฉพาะรายการที่เลือกเท่านั้น
                </div>
                <div v-else>
                  แพ็คของชิ้นอื่นด้วยหากมีมาเพิ่ม
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="12" >
              <b-form-group label="หมายเหตุ :" label-class="py-0 font-weight-bolder" label-cols-md="3">
                {{this.requestInfo[0].requestRemark}}
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BTable, BFormGroup, BButton, BCardBody, BCard, BSpinner, BRow, BCol, BFormRadioGroup, BCardHeader,
  VBToggle, BCollapse, BForm, BTooltip
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import axios from "axios";
import { format_price, formatDatetime } from '@/views/global_function.js'
export default {
  name: 'Taobao2youViewDetail',

  components: {
    BTable, BFormGroup, BButton, BCardBody, BCard, BSpinner, BRow, BCol, BFormRadioGroup, BCardHeader,
    VBToggle, BCollapse, BForm, BTooltip
   },

   directives: {
     Ripple,
    'b-toggle': VBToggle,
  },

  data() {
    return {
      requestInfo: [],
      requestFields: [
        { key: 'trackingNo', label: 'trackingNo' },
        { key: 'remark', label: 'หมายเหตุ' },
        { key: 'receiveDate', label: 'รับเข้าโกดังจีน' },
        { key: 'offChinaDate', label: 'ออกจากจีน' },
        { key: 'arrivedThaiDate', label: 'ถึงไทย'},
        { key: 'requestId', label: 'ลบ', thClass: 'text-center', tdClass: 'text-center' },
      ],

      loadpage: true,
    };
  },

  created() {
    this.loadRequestInfo()
  },

  methods: {
    format_price,
    formatDatetime,
    async loadRequestInfo() {
      this.loadpage = await true
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const requestId = await urlParams.get('rid')
      let response = await axios.post(
        taobaoService_dotnet + 'app/Request/load-request-packing-info',
        {
          "requestID": parseInt(requestId)
        },
        { headers: header_token }
      );
      this.requestInfo = response.data
      if (await response.data.length == 0) {
        this.$router.push({path: '/customer-shipping/status'})
      }
      this.loadpage = false
    },
    async deleteRequestPacking(item) {
      this.$swal({
        title: 'ต้องการลบรายการแจ้งออกของ ?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการลบรายการแจ้งออกของ TrackingNo. : " + item.trackingNo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/Request/delete-requested-track',
            {
              "requestID": item.requestId,
              "trackingNo": item.trackingNo
            },
            { headers: header_token }
          );
          this.loadRequestInfo()
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
      display: none;
  }
</style>